export const SHIPX_AGENCY_MAPPINGS_RESET_STATE = 'SHIPX_AGENCY_MAPPINGS_RESET_STATE';
export const SHIPX_AGENCY_MAPPINGS_CURRENT_ITEM = 'SHIPX_AGENCY_MAPPINGS_CURRENT_ITEM';

export const SHIPX_AGENCY_MAPPINGS_REQUEST_LOADING = 'SHIPX_AGENCY_MAPPINGS_REQUEST_LOADING';
export const SHIPX_AGENCY_MAPPINGS_REQUEST_SUCCESS = 'SHIPX_AGENCY_MAPPINGS_REQUEST_SUCCESS';
export const SHIPX_AGENCY_MAPPINGS_REQUEST_FAILED = 'SHIPX_AGENCY_MAPPINGS_REQUEST_FAILED';

export const SHIPX_AGENCY_MAPPINGS_CURRENT_ACTION = 'SHIPX_AGENCY_MAPPINGS_CURRENT_ACTION';
export const SHIPX_AGENCY_MAPPINGS_RESET_ACTION = 'SHIPX_AGENCY_MAPPINGS_RESET_ACTION';